import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { useTimezoneStore } from 'src/store/timezoneStore';
import { dateUtils } from 'src/utils/date';
import { TextField } from '@mui/material';

interface LocalizedDateTimeInputProps {
  label: string;
  [key: string]: any;
}

export const LocalizedDateTimePicker = ({
  label,
  value,
  onChange,
  ...props
}: LocalizedDateTimeInputProps) => {
  const { timezone, locale } = useTimezoneStore();

  const localizedValue = dateUtils.fromUTC(value, timezone);

  const handleChange = (newValue: any) => {
    if (newValue && onChange) {
      const utcValue = dateUtils.toUTC(
        newValue.format('YYYY-MM-DD HH:mm:ss'),
        timezone
      );
      onChange(utcValue);
    } else if (onChange) {
      onChange(null);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={locale}>
      <DateTimePicker
        label={`${label} (${timezone})`}
        value={localizedValue}
        onChange={handleChange}
        renderInput={(params) => <TextField {...params} />}
        {...props}
      />
    </LocalizationProvider>
  );
};
